import './_Notifications.scss';
import { Dropdown, Button, Badge, Icon } from '@arkas/coreui';
import { applicationState } from '@/states/applicationState';
import { connect } from 'react-redux';
import mutabakatModel from '@/states/mutabakatModel';
import { NotificationDto } from '@emutabakat-types/mutabakat';
import NotificationsContent from './NotificationsContent';
import React from 'react';
import store from '@/store';

interface NotificationsProps {
  notifications: NotificationDto[];
  random: number;
}

interface NotificationStates {}

/**
 * Notifications Component
 */
class Notifications extends React.Component<
  NotificationsProps,
  NotificationStates
> {
  componentDidMount() {
    this.handleUpdateState();
  }

  componentDidUpdate(prevProps: NotificationsProps) {
    const { random } = this.props;
    if (prevProps.random !== random) {
      this.getNotifications();
    }
  }

  getNotifications() {
    const user = store.getState().kullaniciModel.currentUser;
    mutabakatModel.getAllKullaniciNotifikasyon(user.id);
    this.handleUpdateState();
  }

  onVisibleChange = () => {
    this.getNotifications();
  };

  handleUpdateState = () => {
    this.setState({
      notifications: store.getState().mutabakatModel.notifications
    });
  };

  handleClearNotifications = () => {
    const user = store.getState().kullaniciModel.currentUser;
    mutabakatModel.deleteAllKullaniciNotifikasyon(user.id);
    mutabakatModel.setRandom(Math.random());
  };

  render() {
    const { notifications } = this.props;
    return (
      <Dropdown
        overlay={
          <NotificationsContent
            notifications={notifications}
            handleClearTasks={this.handleClearNotifications}
          />
        }
        trigger={['click']}
        placement="bottomRight"
        onVisibleChange={this.onVisibleChange}
      >
        <Button ghost={true} className="notifications-button">
          <Badge
            style={{ backgroundColor: '#fff', color: '#999' }}
            count={notifications ? notifications.length : 0}
            overflowCount={9}
            offset={[0, -4]}
          >
            <Icon type="bell" />
          </Badge>
        </Button>
      </Dropdown>
    );
  }
}

const mapStateToProps = (state: applicationState) => ({
  notifications: state.mutabakatModel.notifications,
  random: state.mutabakatModel.random
});

export default connect(mapStateToProps)(Notifications);
